<div class="kt-portlet container">
	<div class="kt-portlet__head">
		<div class="encabezado mt-3">
			<h1 class="titulo"><i class="fas fa-tablet-rugged"></i>&nbsp;Dispositivos</h1>
		</div>
		<div class="mt-3">
			<button id="agregarBoton" mat-raised-button class="btn btn-success" (click)="altaDispositivo()"
				*ngxPermissionsOnly="[permisoAgregarDispositivo]" style="margin-right: 15px;"><i
					class="fas fa-plus"></i>&nbsp;Agregar</button>

			<kt-boton-exportar-tabla [tipoBoton]="'grid'" [nombreArchivo]="'Dispositivos'" [datos]="datosReporte" [buttonDisabled]="isDisabled">
			</kt-boton-exportar-tabla>
		</div>
	</div>
	<mat-divider></mat-divider>
	<div class="kt-portlet__body">
		<div class="kt-section">
			<div class="kt-section__content">
				<div class="contenedor-modal">
					<div class="data-grid">
						<dx-data-grid id="gridContainer" [columnHidingEnabled]="true"
							[dataSource]="dispositivosRegistros" [showBorders]="true" [rowAlternationEnabled]="true">
							<dxo-paging [pageSize]="7"></dxo-paging>
							<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[7, 10, 50, 100]"
								[showInfo]="true">
							</dxo-pager>
							<dxo-group-panel [emptyPanelText]="mensajeAgrupar" [visible]="true"></dxo-group-panel>
							<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
							<dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>
							<ng-container
								*ngxPermissionsOnly="[permisoActualizarDispositivo, permisoEliminarDispositivo]">
								<dxi-column caption="Acciones" cellTemplate="Abrir" alignment="center">
								</dxi-column>
							</ng-container>
							<dxi-column dataField="imei" caption="IMEI" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="numeroTelefonico" caption="Teléfono" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="numeroSerie" caption="Número de Serie" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="marca" caption="Marca" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="modelo" caption="Modelo" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="sim" caption="Sim" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="estatus" caption="Estatus" alignment="center" cellTemplate="color">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<div *dxTemplate="let d of 'Abrir'" style="text-align: center;">
								<ng-container *ngxPermissionsOnly="[permisoActualizarDispositivo]">
									<dx-button valueExpr="id" id="actualizarButton" class="btnAcciones"
										(click)="editarDispositivo(d.data.imei)">
										<i class="fa fa-edit"></i>
									</dx-button>
								</ng-container>
								<ng-container *ngxPermissionsOnly="[permisoEliminarDispositivo]">
									<dx-button *ngIf="d.data.estatus != 'Asignado'" valueExpr="id" id="deleteButton"
										class="btnAcciones" (click)="eliminarDispositivo(d.data)">
										<i class="fa fa-trash"></i>
									</dx-button>
								</ng-container>
								<!--baja-->
								<ng-container *ngIf="d.data.estatus === 'Revisión' || d.data.estatus === 'Baja'">
									<dx-button id="product1" valueExpr="id" id="botonWhiteBlue" class="btnAcciones"
										(click)="cambiarEstatus(d.data.imei, 0)" matTooltip="Baja">
										<i class="fa fa-arrow-down"></i>
									</dx-button>
								</ng-container>
								<!--disponible-->
								<ng-container *ngIf="d.data.estatus === 'Revisión' || d.data.estatus === 'Baja'">
									<dx-button valueExpr="id" id="botonWhiteBlue" class="btnAcciones"
										(click)="cambiarEstatus(d.data.imei, 1)" matTooltip="Disponible">
										<i class="fa fa-arrow-up"></i>
									</dx-button>
								</ng-container>
							</div>
							<div *dxTemplate="let p of 'color'">
								<p *ngIf="p.data.estatus === 'Baja'" class="rojo">{{p.data.estatus}}</p>
								<p *ngIf="p.data.estatus === 'Disponible'" class="verde">{{p.data.estatus}}</p>
								<p *ngIf="p.data.estatus === 'Asignado'" class="azul">{{p.data.estatus}}</p>
								<p *ngIf="p.data.estatus === 'Revisión'" class="naranja">{{p.data.estatus}}</p>
							</div>
						</dx-data-grid>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
